import { render } from "./Item.vue?vue&type=template&id=6f11bc4f&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=6f11bc4f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f11bc4f"

export default script